import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconCitySolid = function IconCitySolid(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-city-solid"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "M22 21a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1c0-.46.32-.84.75-.95V7.72c0-.33.25-.69.57-.8L8.19 5.2l.17-.03c.23 0 .4.17.4.43V12h-2.4a.6.6 0 0 0-.6.6V20h1v-7h5v7h1v-7.4a.6.6 0 0 0-.6-.6h-2.4V2.6c0-.33.26-.6.6-.6h4.8l.1.02V20h1V8.86l4.42 1.52c.32.1.57.46.57.8v8.87c.43.11.75.49.75.95"
  }, pathRest)));
};
IconCitySolid.displayName = 'InlineIcon(IconCitySolid)';
IconCitySolid.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconCitySolid };
